<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { setLanguage } from './lang'
import moment from 'moment'
export default {
  name: 'App',
  watch: {
    '$i18n.locale': {
      handler: function (lang) {
        if (lang) {
          setLanguage(lang)
          moment.locale(lang === 'zh' ? 'zh-cn' : lang)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  @import "styles/index";

  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue